export default __webpack_public_path__ + "static/media/ic_public_48px.51666404.svg";